import { useNavigate } from 'react-router-dom'

import { ErrorScreen } from '@paysense-india-services/elevate-web'

import { getImageUrl } from '@/constants/images'
import { ROUTES } from '@/constants/routes'

const NotFoundPage = () => {
  const navigate = useNavigate()

  const ErrorIcon = () => {
    return <img alt='Page not found' height={190} src={getImageUrl('error')} width={234} />
  }

  const handleButtonClick = () => {
    navigate(ROUTES.DASHBOARD)
  }

  return (
    <ErrorScreen
      description='Page Not Found!!'
      ErrorImage={<ErrorIcon />}
      onButtonClick={handleButtonClick}
    />
  )
}

export default NotFoundPage
